export const appLang = {
  language: 'pl',
};
